import * as S from "./ModalGuardian.style";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Guardian } from "@/common/types/student";
import { showAlert } from "../../Alert";
import { AlertText } from "@/components/atoms/AlertText";
import { SearchBox } from "@/components/molecules/SearchBox";
import { GET_GUARDIAN } from "@/common/querykeys";
import { useRecoilState } from "recoil";
import { ResultCardList } from "@/components/molecules/ResultCardList";
import { guardianUserState } from "@/common/states/user";
import { ModalProps, Modals } from "../../../organisms/Modals";

interface ModalGuardianProps extends ModalProps {}

export const ModalGuardian = ({ setModalShow }: ModalGuardianProps) => {
  const [isCheckd, setIsCheckd] = useState(false);
  const [guardianInfo, setGuardianInfo] = useRecoilState(guardianUserState);
  const [selectedGuardian, setSelectedGuardian] = useState<Guardian | null>(
    null
  );

  const handleSave = () => {
    if (selectedGuardian) {
      if (isCheckd) {
        setGuardianInfo(selectedGuardian);
        showAlert(
          "법정보호자 연결이 완료되었습니다. \n\n 법정보호자 계정에서 다시 로그인하시거나, \n'설정 > 내 계정 관리'에서 연결 상태를 \n확인해주십시오."
        );
        setModalShow(false);
      } else {
        showAlert("조회한 결과를 선택해 주세요.");
      }
    } else {
      showAlert("검색한 결과가 없습니다.");
    }
  };

  const { data: guardians } = useQuery<Guardian[]>({
    queryKey: [GET_GUARDIAN],
    queryFn: async () => {
      return await request<Guardian[]>({
        method: "GET",
        url: `/guardian`,
      });
    },
  });

  const handleClick = (inputValue: string) => {
    const guardian = guardians?.find((guard) => guard.id === inputValue);
    setSelectedGuardian(guardian || null);
  };

  const handleRadioClick = (isChecked: boolean) => {
    if (isChecked) {
      setIsCheckd(true);
    }
  };

  return (
    <Modals
      setModalShow={setModalShow}
      title="법정보호자 찾기"
      modalButtons={
        <>
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="black60"
            label="취소"
            onClick={() => setModalShow(false)}
          />
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="저장"
            onClick={handleSave}
          />
        </>
      }
    >
      <S.GuardianForm>
        <S.SearchBox>
          <SearchBox
            label="법정보호자 UID"
            size="lg"
            handleClick={handleClick}
          />
          <span>
            * 법정보호자 계정의 ‘설정 &gt; 내 정보’에서 확인 가능합니다.
          </span>
        </S.SearchBox>

        {/* 검색결과가 있을 경우 하단 리스트 표기 */}
        {selectedGuardian ? (
          <ResultCardList
            data={selectedGuardian}
            name="guardian"
            handleRadioClick={handleRadioClick}
          />
        ) : (
          <AlertText
            mainText="검색 결과가 없습니다."
            subText={<>정확한 법정보호자의 UID를 입력해주세요.</>}
          />
        )}
      </S.GuardianForm>
    </Modals>
  );
};
